import React from "react";

/**
 * 미납 징수 범위 설명.
 *
 * "1개월 = 이번 달 회비만 징수"로 읽히기 쉬운데 실제로는 다르다.
 * 크론(cronJobFee)은 미납 징수와 당월 회비 징수를 따로 돌리고,
 * 이 설정은 앞의 미납 징수에만 걸린다. 당월 회비는 항상 전액 징수된다.
 * 오해 소지가 커서 예시까지 함께 보여준다.
 */
const DefaultRangeHelp = () => (
  <div className="alert alert-info f-s-12 m-t-5 m-b-0 p-10">
    <div className="m-b-5">
      <b>당월 회비와는 별개입니다.</b> 밀린 회비를 한 번에 얼마까지 걷을지만
      정합니다. 당월 회비는 범위와 관계없이 항상 전액 징수됩니다.
    </div>
    <div className="m-b-5">
      납부일마다 누적 미납액 중 <b>‘월 회비 × 개월수’</b>까지만 징수합니다.
      (전체 = 누적 미납 전액)
    </div>
    <div className="m-b-5">
      예) 월 회비 10,000원 · 누적 미납 50,000원인 회원
      <div className="m-t-5">
        <table className="table table-bordered table-sm f-s-11 m-b-0 bg-white">
          <thead>
            <tr>
              <th>범위</th>
              <th className="text-right">미납 징수</th>
              <th className="text-right">당월 회비</th>
              <th className="text-right">총 출금</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>전체</td>
              <td className="text-right">50,000</td>
              <td className="text-right">10,000</td>
              <td className="text-right">
                <b>60,000</b>
              </td>
            </tr>
            <tr>
              <td>1개월</td>
              <td className="text-right">10,000</td>
              <td className="text-right">10,000</td>
              <td className="text-right">
                <b>20,000</b>
              </td>
            </tr>
            <tr>
              <td>3개월</td>
              <td className="text-right">30,000</td>
              <td className="text-right">10,000</td>
              <td className="text-right">
                <b>40,000</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div className="text-muted">
      · 어느 달의 미납분인지 구분하지 않고, 누적 미납액에서 상한만큼
      떼어냅니다.
      <br />· 잔액이 상한에 못 미치면 미납분은 <b>부분 징수 없이 건너뜁니다.</b>
      <br />· 징수는 회원 본인 납부일(5일 또는 25일)에만 이뤄져 월 1회입니다.
    </div>
  </div>
);

export default DefaultRangeHelp;
